import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesWorkflowsImportRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflows-import',
	path: '/plugins/servlet/wfshare-(import|export)',
};
